import React from 'react';
import { Button, Typography } from 'antd';
import { ReloadOutlined, LockOutlined } from '@ant-design/icons';
import './attempt-question-not-loaded.scope.css';

const { Title, Text } = Typography;

interface AttemptQuestionNotLoadedProps {
	errorMessage?: string;
	retryFunc: () => void;
}

export function AttemptQuestionNotLoaded(props: AttemptQuestionNotLoadedProps) {
	const { retryFunc, errorMessage } = props;
	const isPermissionError = errorMessage?.toLowerCase().includes('not allowed')
		|| errorMessage?.toLowerCase().includes('not authorized');

	return (
		<div className="attempt-question-error-main">
			<div>
				{isPermissionError ? (
					<>
						<Title level={2} style={{ marginBottom: '16px' }}>
							Access Restricted
						</Title>
						<Text
							type="secondary"
							style={{ fontSize: '16px', marginBottom: '20px', display: 'block' }}
						>
							You must complete and submit the current section
							before accessing questions from other sections.
						</Text>
						<Text type="secondary" style={{ marginTop: '16px', display: 'block' }}>
							If you believe this section should be accessible, please contact your invigilator.
						</Text>
					</>
				) : (
					<>
						<Title level={2} style={{ marginBottom: '24px' }}>
							Oops! Something went wrong.
						</Title>
						<Text
							type="secondary"
							style={{ fontSize: '16px', marginBottom: '16px', display: 'block' }}
						>
							We couldn&apos;t load the question details. This may be due to:
						</Text>
						<ul className="attempt-question-eror-list">
							<li>Network issues</li>
							<li>Request timeout</li>
						</ul>
						<div className="retry-button-container">
							<Button
								type="primary"
								onClick={retryFunc}
								size="large"
								style={{ width: 'fit-content', marginTop: '8px' }}
								icon={<ReloadOutlined />}
							>
								Retry
							</Button>
						</div>
					</>
				)}
			</div>
		</div>
	);
}
